import {FETCH_ANALYSIS_LEVEL_GUIDE, FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS, FETCH_ANALYSIS_LEVEL_GUIDE_ERROR, RESET_ANALYSIS_LEVEL_GUIDE} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ANALYSIS_LEVEL_GUIDE: {
      return {...state, error: '', loading: true};
    }
    case FETCH_ANALYSIS_LEVEL_GUIDE_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case FETCH_ANALYSIS_LEVEL_GUIDE_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case RESET_ANALYSIS_LEVEL_GUIDE: {
      return INIT_STATE;
    }
    default:
      return state;
  }
}
